let mobileSwiper = [];
let isMobile = false;

const resize = () => {
  if (document.documentElement.clientWidth < 1071 && isMobile === false) {
    isMobile = true;
    mobileSwiper = new Swiper('.swiper-mobile', {
      slidesPerView: 1,
      spaceBetween: 20,
      allowTouchMove: true,
      slideVisibleClass: 'swiper-slide-visible',
      watchSlidesProgress: true,
      scrollbar: {
        el: ".swiper-mobile__scrollbar",
        dragSize: 35,
        dragClass: 'swiper-mobile__drag'
      },
    })
  } else if (document.documentElement.clientWidth >= 1071) {
    if (isMobile === true) {
      isMobile = false;
      if (Array.isArray(mobileSwiper)) {
        mobileSwiper.forEach(item => {
          item.destroy()
        })
      } else {
        mobileSwiper.destroy()
      }
    }
  }
}

resize();
window.addEventListener('resize', resize)

const heroSwiper = new Swiper('.hero-swiper', {
  slidesPerView: 1,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
  },
  scrollbar: {
    el: ".hero__scrollbar",
    dragSize: 35,
    dragClass: 'hero__drag'
  },
  navigation: {
    nextEl: ".hero__arrow_forward",
    prevEl: ".hero__arrow_back",
  },
});

const specialOfferSwiper = new Swiper('.special-offer-swiper', {
  slidesPerView: 1,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
    1071: {
      allowTouchMove: true,
    }
  },
  navigation: {
    nextEl: ".special-offer__arrow_forward",
    prevEl: ".special-offer__arrow_back",
  },
  scrollbar: {
    el: ".special-offer__scrollbar",
    dragSize: 35,
    dragClass: 'special-offer__drag'
  },
});

const recomendSwiper = new Swiper('.recommend-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
    1071: {
      slidesPerView: 3,
      spaceBetween: 30,
      allowTouchMove: true,
    }
  },
  scrollbar: {
    el: ".recommend-swiper__scrollbar",
    dragSize: 35,
    dragClass: 'recommend-swiper__drag'
  },
  navigation: {
    nextEl: ".recommend__button_forward",
    prevEl: ".recommend__button_back",
  },
});

const swiper3 = new Swiper('.why-us-swiper', {
  allowTouchMove: true,
  spaceBetween: 50,
  initialSlide: 0,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".why-us-swiper__arrow_forward",
    prevEl: ".why-us-swiper__arrow_back",
  },
  pagination: {
    el: ".why-us__pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + ' ' + 'why-us__bullet' + '">' + (index + 1) + "</span>";
    },
  },
});

const videoSwiper = new Swiper('.video-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
    1071: {
      slidesPerView: 3,
      allowTouchMove: true,
    }
  },
  scrollbar: {
    el: ".video-swiper__scrollbar",
    dragSize: 35,
    dragClass: 'video__drag'
  },
  navigation: {
    nextEl: ".video__button_forward",
    prevEl: ".video__button_back",
  },
});

const membersSwiper = new Swiper('.other-members-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
    1071: {
      slidesPerView: 3,
      allowTouchMove: true,
    }
  },
  scrollbar: {
    el: ".other-members-swiper__scrollbar",
    dragSize: 35,
    dragClass: 'other-members-swiper__drag'
  },
  navigation: {
    nextEl: ".other-members__button_forward",
    prevEl: ".other-members__button_back",
  },
});

const gallerySwiper = new Swiper('.gallery-swiper', {
  slidesPerView: 1,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
    1071: {
      allowTouchMove: true,
    }
  },
  scrollbar: {
    el: ".gallery-swiper__scrollbar",
    dragSize: 35,
    dragClass: 'gallery-swiper__drag'
  },
  navigation: {
    nextEl: ".gallery__button_forward",
    prevEl: ".gallery__button_back",
  },
});

const articlesSwiper = new Swiper('.articles-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
    1071: {
      slidesPerView: 3,
      allowTouchMove: true,
    }
  },
  scrollbar: {
    el: ".articles-swiper__scrollbar",
    dragSize: 35,
    dragClass: 'articles-swiper__drag'
  },
  navigation: {
    nextEl: ".articles__button_forward",
    prevEl: ".articles__button_back",
  },
});

document.querySelectorAll('.section').forEach((item) => {
  const cardText = item.querySelectorAll('.card__text')
  cardText.forEach((item, index) => {
    if (item.innerHTML.replace(/\s+/g, ' ').trim().split(' ').length > 45) {
      let flag = false;
      const button = document.createElement('button')
      const textFull = item.innerHTML;
      const textSplit = item.innerHTML.replace(/\s+/g, ' ').trim().split(' ', 40).join(' ')
      item.innerHTML = textSplit;
      button.innerHTML = item.dataset.show;
      button.classList.add('card__show-more')
      let height
      setTimeout(() => {
        height = height ? height : item.parentElement.parentElement.clientHeight;
        for (let i = 0; i < cardText.length; i++) {
          // cardText[i].parentElement.parentElement.style.minHeight = height + 'px';
        }
      }, 500)
      button.addEventListener('click', (e) => {
        item.classList.toggle('card__text_active')
        for (let i = 0; i < cardText.length; i++) {
          cardText[i].parentElement.parentElement.style.height = !cardText[i].classList.contains('card__text_active') ? height + 'px' : 'none';
        }
        for (let i = 0; i < cardText.length; i++) {
          if (cardText[i].classList.contains('card__text_active')) {
            cardText[i].parentElement.parentElement.style.height = 'auto';
          }
        }
        item.innerHTML = flag ? textSplit : textFull;
        button.textContent = flag ? item.dataset.show : item.dataset.hide
        flag = !flag
      })
  
      item.parentNode.appendChild(button)
    }
  })
})



//Показать скрыть список
const showList = document.querySelectorAll('.services__button');

showList.forEach(item => {
  item.addEventListener('click', (e) => {
    const temp = document.querySelectorAll('.services__item_hide')
    e.target.style.display = 'none'
    temp.forEach(item => {
      item.style.display = 'list-item';
      item.style.maxHeight = null;
    })
  })
})

const cabinSwiper = new Swiper('.cabin-swiper', {
  slidesPerView: 1,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
  },
  navigation: {
    nextEl: ".cabin__arrow_next",
    prevEl: ".cabin__arrow_prev",
  },
});

const routeToDaySwiper = new Swiper('.route-to-day__swiper', {
  slidesPerView: 1,
  allowTouchMove: true,
  slideVisibleClass: 'swiper-slide-visible',
  watchSlidesProgress: true,
  breakpoints: {
  },
  navigation: {
    nextEl: ".route-to-day__arrow_next",
    prevEl: ".route-to-day__arrow_prev",
  },
});

if (document.querySelector('.tippy')) {
  tippy('.tippy', {
    content: (e) => e.dataset.text,
    placement: 'top-start',
    theme: 'tomato',
    arrow: true,
  });
}

if (document.querySelector('#map')) {
  const map = document.querySelector('#map')
  ymaps.ready(init);
  function init() {
    // Создание карты.
    var myMap = new ymaps.Map("map", {
      center: map.dataset.center.split(','),
      zoom: 18,
      controls: []
    });
    var myPlacemark = new ymaps.Placemark(map.dataset.coord.split(','), {
      hintContent: map.dataset.hint,
      balloonContent: map.dataset.address
    }, {
      iconLayout: 'default#image',
      iconImageHref: map.dataset.marker,
      iconImageSize: [86, 120],
      iconImageOffset: [-43, -100]
    });
    myMap.geoObjects.add(myPlacemark)

    var zoom = new ymaps.control.ZoomControl({
      options: {
        size: 'small',
        position: {
          right: 10,
          left: 'auto',
          top: 200
        }
      }
    })
    var geo = new ymaps.control.GeolocationControl({
      options: {
        position: {
          right: 10,
          left: 'auto',
          top: 270
        }
      }
    })
    myMap.controls.add(zoom)
    myMap.controls.add(geo)
  }

}

document.querySelectorAll('.hero__container').forEach(item => {
  const top = document.querySelector('.header')?.clientHeight || 0;
  const bottom = document.querySelector('.margin-bottom') || false;
  let bottomItem
  if (bottom) {
    bottomItem = window.getComputedStyle(bottom)?.marginTop;
    bottomItem = bottomItem.substr(1)
  } else {
    bottomItem = 0
  }
  item.style.marginTop = top - 19 + 'px'
  item.style.marginBottom = bottomItem
})
